import * as types from './constants';

// Get Assignment Creators Performance
export const getAssignmentCreatorsPerformanceRequest = data => (
  { type: types.GET_ASSIGNMENT_CREATORS_PERFORMANCE_REQUEST, payload: data }
);

export const getAssignmentCreatorsPerformanceDone = data => (
  { type: types.GET_ASSIGNMENT_CREATORS_PERFORMANCE_DONE, payload: data }
);

export const getAssignmentCreatorsPerformanceFailed = errors => (
  { type: types.GET_ASSIGNMENT_CREATORS_PERFORMANCE_FAILED, payload: errors }
);

// Operations
export const toggleAssignmentCreatorsPerformance = data => (
  { type: types.TOGGLE_ASSIGNMENT_CREATORS_PERFORMANCE, payload: data }
);

export const toggleAllAssignmentCreatorsPerformance = data => (
  { type: types.TOGGLE_ALL_ASSIGNMENT_CREATORS_PERFORMANCE, payload: data }
);

export const setFilter = data => (
  { type: types.SET_ASSIGNMENT_CREATORS_PERFORMANCE_FILTER, payload: data }
);

export const setAllFilters = data => (
  { type: types.SET_ASSIGNMENT_CREATORS_PERFORMANCE_ALL_FILTERS, payload: data }
);

export const clearFilters = (filterToUpdate, mobile) => (
  { type: types.CLEAR_ASSIGNMENT_CREATORS_PERFORMANCE_FILTERS, payload: { filterToUpdate, mobile } }
);

export const assignmentCreatorsPerformanceSetPage = data => (
  { type: types.ASSIGNMENT_CREATORS_PERFORMANCE_SET_PAGE, payload: data }
);